import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface EmptyStateSubtitleProps extends HTMLAttributes<HTMLParagraphElement> {
  ref?: Ref<HTMLParagraphElement>;
}

export const EmptyStateSubtitle = ({ className, ref, ...props }: EmptyStateSubtitleProps) => (
  <p
    ref={ref}
    data-slot="empty-state-subtitle"
    className={cn("max-w-sm text-sm font-normal leading-normal text-muted-foreground", className)}
    {...props}
  />
);
